export const GUARANTOR_ROUTES = [
  'GuarantorName',
  'GuarantorIdentification',
  'GuarantorResidency',
  'GuarantorProfessional',
  'GuarantorFinancial',
  'GuarantorTax'
]

export const TENANT_GUARANTOR_ROUTES = [
  'TenantGuarantorName',
  'TenantGuarantorIdentification',
  'TenantGuarantorResidency',
  'TenantGuarantorProfessional',
  'TenantGuarantorFinancial',
  'TenantGuarantorTax'
]
